import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useStore } from "../../context/StoreContext";
import { money } from "../../lib/shop";

export function useQuote(extraZone) {
  const { cart, zoneId, discountCode } = useStore();
  const [quote, setQuote] = useState(null);
  const zone = extraZone !== undefined ? extraZone : zoneId;
  useEffect(() => {
    if (!cart.length) return setQuote(null);
    const items = cart.map(({ product_id, size, colour, qty }) => ({ product_id, size, colour: colour || "", qty }));
    const t = setTimeout(() => {
      api.post("/cart/quote", { items, zone_id: zone || null, discount_code: discountCode || null })
        .then((r) => setQuote(r.data)).catch(() => {});
    }, 200);
    return () => clearTimeout(t);
  }, [cart, zone, discountCode]);
  return quote;
}

export function Totals({ quote, children }) {
  return (
    <div className="space-y-3 text-sm" data-testid="order-totals">
      <div className="flex justify-between"><span className="text-zinc-400">Subtotal</span><span data-testid="totals-subtotal">{money(quote?.subtotal)}</span></div>
      <div className="flex justify-between"><span className="text-zinc-400">Delivery {quote?.zone ? `(${quote.zone.name})` : ""}</span>
        <span data-testid="totals-delivery">{quote?.zone ? (quote.delivery_fee ? money(quote.delivery_fee) : "FREE") : "Choose option"}</span></div>
      <div className="flex justify-between"><span className="text-zinc-400">Discount {quote?.discount ? `(${quote.discount.code})` : ""}</span>
        <span className="text-emerald-400" data-testid="totals-discount">-{money(quote?.discount?.amount || 0)}</span></div>
      {children}
      <div className="flex justify-between border-t border-white/10 pt-4 text-lg font-extrabold"><span>Total</span><span className="text-gold" data-testid="totals-total">{money(quote?.total)}</span></div>
    </div>
  );
}

export function DiscountBox() {
  const { discountCode, setDiscountCode } = useStore();
  const [code, setCode] = useState(discountCode);
  return (
    <div className="flex gap-2">
      <input className="field uppercase" placeholder="Discount code" value={code} onChange={(e) => setCode(e.target.value)} data-testid="discount-code-input" />
      <button type="button" className="chip !px-5 hover:border-[#d4af37]" onClick={() => setDiscountCode(code.trim().toUpperCase())} data-testid="discount-apply-button">Apply</button>
    </div>
  );
}
